<template>
  <iframe :src="iframeSrc"></iframe>
</template>
<script>
  export default {
    data(){
      return {
        iframeSrc: ''
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        vm.$store.commit('setPageTitle', to.query.name);
        vm.$store.commit('setState', {name: 'contentMarginBottom', value: 0})
        vm.iframeSrc = to.query.linksTo;
      });
    },
    beforeRouteLeave(to, from, next){
      this.$store.commit('setState', {name: 'contentMarginBottom', value: 60})
      next();
    }
  }
</script>
<style lang="less" scoped>
  iframe{
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    border:none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// index.vue?0045fbf8